<template>
<div id="Home">
    <b-container>
        <b-row>
            <b-col cols="12">
                <b-navbar toggleable="lg" type="dark" variant="dark">
                    <img class="navLogo" src="../../assets/logo.png" alt="">

                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav>
                        <!-- Right aligned nav items -->
                        <b-navbar-nav class="ms-auto">
                            <b-nav-item @click="scrollToID('Home')">HOME</b-nav-item>
                            <b-nav-item @click="scrollToID('Roadmap')">ROADMAP</b-nav-item>
                            <b-nav-item @click="scrollToID('About')">ABOUT</b-nav-item>
                            <b-nav-item @click="scrollToID('Team')">TEAM</b-nav-item>
                            <b-nav-item @click="scrollToID('Whitepaper')">WHITEPAPER</b-nav-item>
                            <b-nav-item @click="routeToMint()" disabled>MINT</b-nav-item>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://twitter.com/adventuresofb11" target="_blank" class="socialIcon"><b-icon  icon="twitter" font-scale="2"></b-icon></a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://discord.gg/8rdC4VGU86" target="_blank" class="socialIcon"><b-icon  icon="discord" font-scale="2"></b-icon></a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://www.instagram.com/adventuresofb11/" target="_blank" class="socialIcon"><b-icon  icon="instagram" font-scale="2"></b-icon></a>
                        </b-navbar-nav>
                        
                    </b-collapse>

                </b-navbar>
            </b-col>
        </b-row>
    </b-container>
    
</div>
</template>

<script>
export default {
    name: "NavBar",
    methods:{
        scrollToID(element) {
            document.getElementById(element).scrollIntoView();
        },
        routeToMint()
        {
            this.$router.push({ name: 'Mint' })
        }
    }
    
}
</script>

<style scoped>
.navLogo
{
    width: 8%;
}
.bg-dark {
    background: transparent !important;
}
.navbar-dark .navbar-nav .nav-link {
    color: white !important;
    font-size: 1.5vh;
    font-style: italic;
    font-weight: bolder;
    letter-spacing: 0.2vh;
}
.socialIcon
{
    color: white;
    
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation/NavBar.vue